import React from 'react';
import { Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Button,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableRow,
    Paper
}
from '@mui/material';
import { CustomTableCell } from '../../../common/CustomTableCell';

const PolicyVechileDetails = ({vehicleDetails, vehicleModel, setVechicleModel}) => {

    return(
        <>
            <Dialog maxWidth="lg" fullWidth open={vehicleModel} onClose={(event, reason) => { if (reason === "backdropClick" || reason === "escapeKeyDown") { return; } setVechicleModel(false); }} disableScrollLock={true} keepMounted={false} hideBackdrop={false} style={{ zIndex: 1300 }}>
                <DialogTitle>Vehicle Details</DialogTitle>
                <DialogContent>
                    <TableContainer sx={{ verticalAlign: 'Top', boxShadow: 'none', marginTop: '15px'}} component={Paper}>
                        <Table sx={{ verticalAlign: 'Top' }}>
                            <TableBody>
                                <TableRow sx={{ verticalAlign: 'Top' }}>
                                    <TableCell>
                                        <Table>
                                            <TableRow>
                                                <TableCell>
                                                    Year:
                                                </TableCell>
                                                <TableCell>{vehicleDetails.year}</TableCell>
                                            </TableRow>
                                            <TableRow>
                                                <TableCell id="lastname">
                                                    Make:
                                                </TableCell>
                                                <TableCell>{vehicleDetails.make}</TableCell>
                                            </TableRow>
                                            <TableRow>
                                                <TableCell id="dateofBirth">
                                                    Model:
                                                </TableCell>
                                                <TableCell>{vehicleDetails.model}</TableCell>
                                            </TableRow>
                                            <TableRow>
                                                <TableCell id="gender">
                                                    VIN:
                                                </TableCell>
                                                <TableCell>{vehicleDetails.vin}</TableCell>
                                            </TableRow>
                                            <TableRow>
                                                <TableCell id="createdby">
                                                    Created By:
                                                </TableCell>
                                                <TableCell>{vehicleDetails.createdBy?.name}</TableCell>
                                            </TableRow>
                                                <TableRow>
                                                <TableCell id="updatedBy">
                                                    Updated By:
                                                </TableCell>
                                                <TableCell>{vehicleDetails.updatedBy?.name}</TableCell>
                                            </TableRow>
                                            <TableRow></TableRow>
                                        </Table>
                                    </TableCell>
                                    <TableCell>
                                        <Table>
                                            <TableRow>
                                                <TableCell id="address">
                                                    Body Type:
                                                </TableCell>
                                                <TableCell>{vehicleDetails.bodyType}</TableCell>
                                            </TableRow>
                                            <TableRow>
                                                <TableCell id="zip">
                                                    Engine Type:
                                                </TableCell>
                                                <TableCell>{vehicleDetails.engineType ? vehicleDetails.engineType : '--'}</TableCell>
                                            </TableRow>
                                            <TableRow>
                                                <TableCell id="city">
                                                    Territory:
                                                </TableCell>
                                                <TableCell>{vehicleDetails.territory ? vehicleDetails.territory : '--'}</TableCell>
                                            </TableRow>
                                            <TableRow>
                                                <TableCell id="state">
                                                    Garaging Zip:
                                                </TableCell>
                                                <TableCell>{vehicleDetails.garaging}</TableCell>
                                            </TableRow>
                                            <TableRow>
                                            <TableCell id="createdat">
                                                Created At:
                                            </TableCell>

                                                <CustomTableCell timestamp={vehicleDetails.createdBy?.timestamp} />
                                        </TableRow>
                                            <TableRow>
                                            <TableCell id="updatedat">
                                                Updated At:
                                            </TableCell>

                                                <CustomTableCell timestamp={vehicleDetails.updatedBy?.timestamp} />
                                        </TableRow>
                                        </Table>
                                    </TableCell>
                                </TableRow>
                            </TableBody>
                        </Table>
                    </TableContainer>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setVechicleModel(false)} variant='outlined'>Cancel</Button>
                </DialogActions>
            </Dialog>
        </>
    )
}

export default PolicyVechileDetails;